import axios from '@/libs/axios'
import { ApiCode } from '@/const/api'
import { handleCatch } from '@/utils'

export default {
  async handleApiResponse(response) {
    const { data } = response
    if (data.code === ApiCode.SUCCESS) {
      return data.data ? data.data : []
    }
    return []
  },
  async insertExaminationRooms(params) {
    try {
      const response = await axios.post('uni/examinationRoomsBatch/create', params)
      const { data } = response
      return { isSuccessful: data.code === ApiCode.SUCCESS, message: data.message }
    } catch (e) {
      handleCatch(e)
    }
  },

  async getExaminationRooms(params) {
    try {
      const response = await axios.get('uni/examinationRoomsBatch', { params })
      const { data } = response
      if (data.code === ApiCode.SUCCESS) {
        return data.data
      }
      return { record: [], total: 0 }
    } catch (e) {
      handleCatch(e)
    }
  },

  async createExaminationRoom(params) {
    try {
      const response = await axios.post('uni/examinationRooms', params)
      const { data } = response
      const isSuccessful = data.code === ApiCode.SUCCESS
      if (isSuccessful) {
        return { isSuccessful, message: data.message }
      }
      return { isSuccessful, message: data.debugMessage }
    } catch (e) {
      handleCatch(e)
    }
    return null
  },
  async updateExaminationRoom(params) {
    try {
      const response = await axios.put(`uni/examinationRooms/${params.id}`, params)
      const { data } = response
      return { isSuccessful: data.code === ApiCode.SUCCESS, message: data.message }
    } catch (e) {
      handleCatch(e)
    }
    return null
  },

  async getCourseSemesterSubjectSelect(params) {
    try {
      const response = await axios.get('uni/course_semester_subjects', { params })
      return this.handleApiResponse(response)
    } catch (e) {
      handleCatch(e)
    }
  },

  async getExaminationSchedulers(params) {
    try {
      const response = await axios.get('uni/examination_schedulers', { params })
      const { data } = response
      if (data.code === ApiCode.SUCCESS) {
        const { records } = data.data
        return records || []
      }
      return []
    } catch (e) {
      handleCatch(e)
    }
  },

  async deleteExaminationRoom(id) {
    try {
      const response = await axios.delete(`uni/examinationRooms/${id}`)
      const { data } = response
      return { isSuccessful: data.code === ApiCode.SUCCESS, message: data.message }
    } catch (e) {
      handleCatch(e)
    }
  },

  async getSubjectByExaminationScheduler(params) {
    try {
      const response = await axios.get('uni/examination_schedulers_batch/getSubjects', { params })
      return this.handleApiResponse(response)
    } catch (e) {
      handleCatch(e)
    }
  },

  async getCourseSemester(params) {
    try {
      const response = await axios.get('uni/examinationRooms/course_semesters', { params })
      return this.handleApiResponse(response)
    } catch (e) {
      handleCatch(e)
    }
  },

  async exportStudentsExaminationRoom(params) {
    try {
      const response = await axios.get('uni/reports/exportPdfStudentsExaminationRoom', { params, responseType: 'blob' })
      return response.data
    } catch (e) {
      handleCatch(e)
    }
  },

  async exportPdfStudentsExaminationScore(params) {
    try {
      const response = await axios.get('uni/reports/exportPdfStudentsExaminationScore', { params, responseType: 'blob' })
      return response.data
    } catch (e) {
      handleCatch(e)
    }
  },

  async getAllRooms(params) {
    try {
      const response = await axios.get('uni/examinationRooms/rooms', { params })
      const { data } = response
      if (data.code === ApiCode.SUCCESS) {
        return data?.data || []
      }
      return []
    } catch (e) {
      handleCatch(e)
    }
  },

  async getAllSubjects(params) {
    try {
      const response = await axios.get('uni/examinationRooms/subjects', { params })
      const { data } = response
      if (data.code === ApiCode.SUCCESS) {
        return data?.data || []
      }
      return []
    } catch (e) {
      handleCatch(e)
    }
  },

  async saveScoresByCreditClass(body) {
    try {
      const response = await axios.post('uni/studentExaminationRooms/saveScoresByCreditClass', body)
      const { data } = response
      return { isSuccessful: data.code === ApiCode.SUCCESS, message: data.message }
    } catch (e) {
      handleCatch(e)
    }
  },

  async getSystemParameterByCode(param) {
    try {
      const response = await axios.get(`uni/parameters/code/${param}`)
      const { data } = response
      if (data.code === ApiCode.SUCCESS) {
        return data.data.value
      }
    } catch (e) {
      handleCatch(e)
    }
    return null
  },
}
